import vars from 'vars'

class Request {

  constructor() {
    this.category = [
      "スキャルプケア",
      "ホームケア",
      "システムケア",
      "ツール",
      "キャンペーン"
    ]
  }

  static(callback) {
    const self = this
    $.ajax({
      url: "/assets/json/items.json"
    }).done(function(res){

      let after = self.setData(res)
      callback(after)

    })
  }

  setData(res) {
    let after = {
      items: res,
      list: res,
      obj: {}
    }

    res.map( (i) => {
      if( after.obj[i.category] ) {
        after.obj[i.category].push(i)
      }
      else {
        after.obj[i.category] = []
        after.obj[i.category].push(i)
      }
    })

    return after
  }

  dummy(n, text) {
    let texts = []
    vars.arrs(n).map( () => {
      texts.push(text)
    })
    return texts.join('')
  }

  placeimg() {
    let size = Number.random(4, 9) * 100
    return `http://placeimg.com/${size}/${size}/any`
  }

  random() {
    const self = this
    let arr = []
    vars.arrs(100).map( () => {
      arr.push({
        "id": Number.random(1, 999999),
        "name": self.dummy(Number.random(1, 10), "ここに商品名が入ります"),
        "category": self.category[Number.random(0, 4)],
        "spec": `${ Number.random(1, 10000) * 10 }g`,
        "price": (Number.random(1, 90000) * 10).format(),
        "img": self.placeimg(),
        "type": "random"
      })
    })

    return self.setData(arr)

  }
}

const req = new Request()
export default req



// WEBPACK FOOTER //
// ./_src/riot/product/request.js